import angular from 'angular'
import 'angulartics'
import register from '../../app/util/register'
import '../../lib/angulartics-mixpanel.min'

var analytics = angular.module(
  'blocks.analytics',
  [
    'angulartics',
    'angulartics.mixpanel'
  ]
)

analytics.run(['$window', '$analytics', function($window, $analytics) {
  // TODO: Add mixpanel key as a constant.
  $window.mixpanel.init('d4e51708d67a35d89cfc70f5804d53d6')
}])

register('blocks.analytics')
  .decorator('$analytics', function($delegate, $window) {
    $delegate.timeEvent = function(eventName) {
      $window.mixpanel.time_event(eventName)
    }

    // See link below for mixpanel api documentation.
    // https://mixpanel.com/help/reference/javascript-full-api-reference
    $delegate.people = {
      set: function(prop, to, cb) {
        $window.mixpanel.people.set(prop, to, cb)
      },

      setOnce: function(prop, to, cb) {
        $window.mixpanel.people.set_once(prop, to, cb)
      },

      increment: function(prop, by, cb) {
        $window.mixpanel.people.increment(prop, by, cb)
      },

      append: function(prop, by, cb) {
        $window.mixpanel.people.append(prop, value, cb)
      }
    }

    return $delegate
  }
)
